import { superstyled } from '@zenbusiness/zui/styles';

export const LoadingContainerStyle = () => ({
  height: '100%',
  textAlign: 'center'
});

export const SpinnerRoot = superstyled({
  name: 'LoadingSpinner',
  slot: 'Root',
  styles: {
    inset: 0,
    position: 'fixed',
    zIndex: '1000',
    display: 'flex',
    alignItems: 'center',
    flexDirection: 'column',
    justifyContent: 'center'
  }
});

export const SpinnerContainer = superstyled({
  name: 'LoadingSpinner',
  slot: 'Container',
  styles: {
    alignSelf: 'stretch',
    justifySelf: 'stretch',
    flexGrow: 1,
    flexShrink: 0,
    flexBasis: 'auto',
    display: 'flex',
    alignItems: 'center',
    flexDirection: 'column',
    justifyContent: 'center'
  }
});
